<template>
<div class="chapter">
<div class="inner_page">
<section title="Dedication">
<p class="ded_pb"><span class="right_1" epub:type="pagebreak" id="page_3" title="3"><span class="right_1" epub:type="pagebreak" id="page_4" title="4">To Sam Reeves and Max DePree,</span></span></p>
<p class="ded">who have taught me so much</p>
<p class="ded">about getting out of the boat</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780310296065_Dedication.vue?906ea252